import { IProductionRecurring } from "../../models";

export const hasActiveProductionRecurring = (
  recurring?: IProductionRecurring,
): boolean => {
  if (!recurring) {
    return false;
  }

  if (!recurring.enableRecurring) {
    return false;
  }

  const times = recurring.times;

  if (!Array.isArray(times)) {
    return false;
  }

  return times.length > 0;
};
